import { Button, Checkbox, FormControlLabel, Grid } from "@mui/material"
import { TCInput } from "components/TopCourtComponents/Input/TopCourtInput"
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"
import React from "react"
import { demoteVerificationStatus } from "services/dashboardServices"

function VerificationProfile ({
    data,
    setReload
}) {

    const demoteVerification = async () => {
        let { data, error } = await demoteVerificationStatus({
            _id: data._id,
            reject: true, verify: false
        })
        if (error) { throw error }
        if (data) { setReload(true) }
    }

    return (
        <Grid>
            {
                data &&
                <>
                    {/* detail verification */}
                    <Grid p={2} xs={12}>
                        <TCLabel style={{
                            fontSize: 16
                        }} bold>Player Verification</TCLabel>
                        <Grid mt={1}>
                            <TCInput label={"ID Name"} value={data.verifyId.idName} disabled={true}/>
                        </Grid>
                        <Grid item xs={12} mt={1}>
                            <TCLabel style={{color: "rgb(133, 133, 133)"}}>Gender</TCLabel>
                            <Grid item container>
                                <Grid item>
                                    <FormControlLabel control={<Checkbox disabled={true} checked={data.gender == "male" ? true : false}/>} label={<TCLabel>Male</TCLabel>} />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel control={<Checkbox disabled={true} checked={data.gender == "female" ? true : false}/>} label={<TCLabel>Female</TCLabel>} /> 
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid mt={1}>
                            <TCLabel style={{color: "rgb(133, 133, 133)"}}>Photo</TCLabel>
                            <img width={'auto'} height={200} src={data.verifyId.idPhoto} alt="" />
                        </Grid>
                        <Grid mt={1} container spacing={1} sx={{
                            textAlign: 'right',
                            justifyContent: 'right'
                        }}>
                            <Grid item>
                                <Button variant='contained' style={{ backgroundColor: '#E35480' }}
                                    onClick={() => { demoteVerification({
                                            _id: data._id,
                                            reject: true, verify: false
                                        }) 
                                    }}
                                >Demote</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            }
        </Grid>
    )
}

export default VerificationProfile